import { render, staticRenderFns } from "./pattern.vue?vue&type=template&id=4a36c824&scoped=true"
import script from "./pattern.vue?vue&type=script&lang=js"
export * from "./pattern.vue?vue&type=script&lang=js"
import style0 from "./pattern.vue?vue&type=style&index=0&id=4a36c824&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a36c824",
  null
  
)

export default component.exports